import adminUser from './adminUser';
import appointment from './appointment';
import calendar from './calendar';
import checkout from './checkout';
import clientList from './clientList';
import entitySettings from './entitySettings';
import groomerForm from './groomerForm';
import groomers from './groomers';
import inventory from './inventory';
import locationForm from './locationForm';
import main from './main';
import otherProvider from './otherProvider';
import paymentHistory from './paymentHistory';
import petInformation from './petInformation';
import provider from './provider';
import providerAppointments from './providerAppointments';
import providerForm from './providerForm';
import recurringAvailability from './recurringAvailability';
import reports from './reports';
import serviceForm from './serviceForm';
import signupForm from './signupForm';
import singleAvailability from './singleAvailability';
import singleRecurring from './singleRecurring';
import singleUnavailability from './singleUnavailability';
import ui from './ui';
import user from './user';

const rootReducer = {
  adminUser,
  appointment,
  calendar,
  checkout,
  clientList,
  entitySettings,
  groomerForm,
  groomers,
  inventory,
  locationForm,
  main,
  otherProvider,
  paymentHistory,
  petInformation,
  provider,
  providerAppointments,
  providerForm,
  recurringAvailability,
  reports,
  serviceForm,
  signupForm,
  singleAvailability,
  singleRecurring,
  singleUnavailability,
  ui,
  user,
};

export default rootReducer;
